import { render, staticRenderFns } from "./banker-coverage.vue?vue&type=template&id=45e2e4c2&"
import script from "./banker-coverage.vue?vue&type=script&lang=js&"
export * from "./banker-coverage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45e2e4c2')) {
      api.createRecord('45e2e4c2', component.options)
    } else {
      api.reload('45e2e4c2', component.options)
    }
    module.hot.accept("./banker-coverage.vue?vue&type=template&id=45e2e4c2&", function () {
      api.rerender('45e2e4c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/theme/components/blok/conversion/banker-coverage.vue"
export default component.exports